import { render } from "./ProfilePanel.vue?vue&type=template&id=00b3575e&scoped=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&lang=js"

import "./ProfilePanel.vue?vue&type=style&index=0&id=00b3575e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b3575e"]])

export default __exports__